export const titles = [
    {
        "title" : "HABLEMOS DE MANTENIMIENTO",
        "subtitle" : "A GRAN ALTURA"
    }
];

export const titlesEn = [
    {
        "title" : "LET'S TALK ABOUT MAINTENANCE",
        "subtitle" : "AT GREAT HEIGHTS"
    }
];